import { useState, useEffect } from "react";
import { View, Text as Text, Flex } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import "./index.css";
import Emitter from "../../../emitter";
import { caseHeadingColors } from "./constants";
import { RootState } from "../../../store/storeConfig";
import { API_ACTIVE_CASE_UPDATE, LIVE_CASE } from "../../../constants/constants";
import { IndividualTask } from "../../../amazon-connect/models/task";
import storeRTK from "../../../store/storeRTK";
import { formatTimeString, formatDuration } from "../../../utils/utils";
import { AlertCircleIcon, MissedCaseIcon } from "../../common/Icons";

const CaseSidebar = (props: any) => {
  let cases = useSelector((state: RootState) => state.cases);
  let history = useSelector((state: RootState) => state.history);
  const tabName = useSelector((state: RootState) => state.common.tab);

  let combinedHistoryItems = [...history.cases];
  let itemToMap =
    tabName === LIVE_CASE ? cases.cases : combinedHistoryItems;

  // Use filteredCases from props if available, otherwise fall back to itemToMap
  const displayItems = props.filteredCases || itemToMap;

  // Use cases.activeCaseID for live cases, otherwise use history item ID
  const [isCaseActive, setIsCaseActive] = useState(
    tabName === LIVE_CASE ? cases.activeCaseID : combinedHistoryItems[0]?.id
  );

  // Update isCaseActive when cases.activeCaseID changes
  useEffect(() => {
    if (tabName === LIVE_CASE) {
      setIsCaseActive(cases.activeCaseID);
    }
  }, [cases.activeCaseID, tabName]);

  const updateCaseHeader = (caseID: any) => {
    setIsCaseActive(caseID);
    tabName === "History" && props.setCaseID(caseID);
    Emitter.emit(API_ACTIVE_CASE_UPDATE, caseID);
  };

  const formatDateTime = (connectedTime: any) => {
    const timeString = formatTimeString(connectedTime);

    // if (isHistory) {
    //   const duration = formatDuration(connectedTime, endTime);
    //   return `${timeString} (${duration})`;
    // }

    return timeString;
  };

  return (
    <View UNSAFE_className="case-sidebar-container">
      {displayItems?.map((c: IndividualTask, index: number) => (
        <div
          key={index}
          onClick={() => {
            updateCaseHeader(c?.id);
          }}
          aria-label={c.customer?.name}
          className={`case-item ${isCaseActive === c.id && "case-item-active"
            } ${cases.activeCaseID === c?.id
              ? `selectedMultiCase color-${caseHeadingColors[index > -1 ? index % 6 : 0]?.name
              }`
              : `color-${caseHeadingColors[index > -1 ? index % 6 : 0]?.name}`
            }`}
        >
          <Flex direction={"column"} width={"95%"}>
            <Flex>
              <Text UNSAFE_className="case-sidebar case-title-truncate">
                {c.customer?.attributes?.CASE_TITLE}
              </Text>
            </Flex>
            <Flex
              UNSAFE_className="case-list-id"
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Flex direction={"row"} gap={"size-500"} alignItems={"center"} width={"100%"}>
                <Text width={'40%'}>{c.customer?.attributes?.CASEID}</Text>
                <Flex direction={"row"} gap={"size-20"} alignItems={"center"} width={'60%'}>{tabName !== LIVE_CASE && c?.self?.missed && (
                  <Flex UNSAFE_className="case-sidebar-missed-icon">
                    <MissedCaseIcon />
                  </Flex>
                )}
                  <Text UNSAFE_className="case-sidebar-time">
                    {formatDateTime(c.self?.connectedTime)}
                  </Text>
                </Flex>
              </Flex>

            </Flex>
          </Flex>
          {c?.customer?.attributes?.PRIORITYCODE && Number(c?.customer?.attributes?.PRIORITYCODE) === 1 && <Flex UNSAFE_className="case-sidebar-alert-icon">
            <AlertCircleIcon color='#d31510' title="" />
          </Flex>}
        </div>
      ))}
    </View>
  );
};

export default CaseSidebar;
